import { Link } from "react-router-dom";
import { User } from "snudbud-backbone-sdk";

interface ChatHeaderProps {
  profile?: User.FetchProfileReturn;
  onExitAttempt: (destination?: string) => void;
}

export default function ChatHeader({ profile, onExitAttempt }: ChatHeaderProps) {
  return (
    <div className="px-4 py-3 border-b flex items-center justify-between bg-white">
      <div className="flex items-center">
        {profile ? (
          <Link
            to={`/profile/${profile.userId}`}
            className="flex items-center"
            onClick={(e) => {
              e.preventDefault();
              onExitAttempt(`/profile/${profile.userId}`);
            }}
          >
            <img
              src={profile.profileImageUrl || "https://via.placeholder.com/40"}
              alt={profile.name}
              className="w-10 h-10 rounded-full object-cover"
            />
            <div className="ml-3 flex flex-col justify-center">
              <div className="font-medium text-gray-900">{profile.name}</div>
              <span className="text-xs text-blue-600 hover:text-blue-800">View profile</span>
            </div>
          </Link>
        ) : (
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse"></div>
            <div className="ml-3">
              <div className="h-5 w-24 bg-gray-200 animate-pulse rounded"></div>
              <div className="h-3 w-16 bg-gray-200 animate-pulse rounded mt-1"></div>
            </div>
          </div>
        )}
      </div>

      <button
        onClick={() => onExitAttempt("/chats")}
        className="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100"
        aria-label="Close chat"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}
